/* WPS refresh: client-side wine filters for sections/wps-collection.liquid */
(function () {
  'use strict';

  var GROUPS = [
    { key: 'type', label: 'Wine type', open: true },
    { key: 'other', label: 'Other', open: true, always: true },
    { key: 'price', label: 'Price', open: true, order: 'fixed' },
    { key: 'country', label: 'Country', open: true },
    { key: 'region', label: 'Region', open: true, limit: 8 },
    { key: 'vivino', label: 'Vivino rating', open: true, order: 'desc' },
    { key: 'pairing', label: 'Food pairing', open: true, limit: 8 },
    { key: 'grape', label: 'Grape', open: false, limit: 8, search: true },
    { key: 'body', label: 'Body', open: false, order: 'fixed', pills: true },
    { key: 'sweetness', label: 'Sweetness', open: false, order: 'fixed', pills: true },
    { key: 'vintage', label: 'Vintage', open: false, order: 'desc', limit: 8 },
    { key: 'size', label: 'Bottle size', open: false, order: 'fixed', pills: true },
    { key: 'extras', label: 'More', open: true, order: 'fixed' }
  ];
  var FIXED_ORDER = {
    price: ['Under $30', '$30 – $50', '$50 – $100', '$100 and over'],
    body: ['Light-bodied', 'Medium-bodied', 'Full-bodied'],
    sweetness: ['Dry', 'Off-dry', 'Sweet'],
    size: ['375 ml', '500 ml', '750 ml', '1.5 L Magnum', '3 L'],
    extras: ['On offer', 'Organic / biodynamic', 'In stock only']
  };

  var WINE_SWATCH = { 'Red wine': '#7b1e2b', 'White wine': '#e3cf7a', 'Rosé wine': '#ec9aa2', 'Sparkling wine': '#d9c46a', 'Dessert wine': '#c98f2e', 'Orange wine': '#e0893a', 'Grappa': '#ffffff', 'Olive oil': '#6b7a2a' };
  // Small line icons for the filter groups and quick picks.
  var UI_ICONS = {
    pairing: '<path d="M7 3v7a2 2 0 01-2 2V21M5 3v5M9 3v5"/><path d="M17 21V3c-2 1.5-3 4-3 7v3h3"/>',
    type: '<path d="M8 3h8l-.6 6.2a3.4 3.4 0 01-6.8 0z"/><path d="M12 12.6V20M8.5 20h7"/>',
    country: '<path d="M5 21V4"/><path d="M5 4h11l-2 4 2 4H5"/>',
    region: '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0113 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
    vivino: '<circle cx="12" cy="9.5" r="6"/><path d="M8.6 14.4L7 21l5-2.6 5 2.6-1.6-6.6"/>',
    grape: '<circle cx="9" cy="10" r="2"/><circle cx="13" cy="10" r="2"/><circle cx="17" cy="10" r="2"/><circle cx="11" cy="14" r="2"/><circle cx="15" cy="14" r="2"/><circle cx="13" cy="18" r="2"/><path d="M13 8V4"/>',
    price: '<path d="M3.5 12.5l8-8H20v8.5l-8 8z"/><circle cx="15.5" cy="8.5" r="1.4"/>',
    body: '<path d="M4 18h16M6 18V12M10 18V8M14 18v-6M18 18V5"/>',
    sweetness: '<path d="M12 3.5c3 3.6 5 6.6 5 9.3a5 5 0 01-10 0c0-2.7 2-5.7 5-9.3z"/>',
    vintage: '<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 10h16M8.5 3v4M15.5 3v4"/>',
    size: '<path d="M10 2.5h4v4.2c1.8 1 3 2.6 3 5V21H7v-9.3c0-2.4 1.2-4 3-5z"/><path d="M7 14h10"/>',
    alcohol: '<path d="M8 3h8l-.6 6.2a3.4 3.4 0 01-6.8 0z"/><path d="M12 12.6V20M8.5 20h7M4 4l16 16"/>',
    other: '<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><circle cx="16.75" cy="16.75" r="3.25"/>',
    extras: '<path d="M12 3l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L12 16.3 6.6 19.2l1.2-5.9L3.4 9.2l6-.7z"/>',
    offer: '<path d="M3.5 12.5l8-8H20v8.5l-8 8z"/><path d="M9.5 14.5l5-5"/><circle cx="10" cy="10" r=".9"/><circle cx="14" cy="14" r=".9"/>',
    leaf: '<path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14z"/><path d="M5 19l7-7"/>',
    feather: '<path d="M20 4c-8 0-13 5-13 13v3"/><path d="M7 14h6M9 10h7"/>',
    bolt: '<path d="M13 2.5L5 13.5h6l-1 8 8-11h-6z"/>',
    coin: '<circle cx="12" cy="12" r="8.5"/><path d="M14.5 9.2c-.5-.8-1.4-1.2-2.5-1.2-1.5 0-2.5.8-2.5 2s1 1.7 2.5 2 2.5.8 2.5 2-1 2-2.5 2c-1.1 0-2-.4-2.5-1.2M12 6.5v11"/>',
    building: '<path d="M4 20V9l8-5 8 5v11"/><path d="M9 20v-6h6v6M3 20h18"/>',
    sparkle: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6"/>'
  };
  function uiIcon(name, size) {
    return '<svg class="wps-ui-icon" width="' + (size || 16) + '" height="' + (size || 16) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (UI_ICONS[name] || '') + '</svg>';
  }
  function esc(v) { return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function parseMap(text) {
    var map = {};
    (text || '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var i = line.indexOf('=');
      var tag = (i > -1 ? line.slice(0, i) : line).trim();
      var label = (i > -1 ? line.slice(i + 1) : line).trim();
      if (tag) map[tag.toLowerCase()] = label || tag;
    });
    return map;
  }

  function splitList(v) {
    return (v || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function uniq(arr) {
    var seen = {};
    return arr.filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; });
  }

  // Price filter value is a whole-dollar range "lo-hi" (f.price=20-80 in the URL).
  var BAND_RANGES = { 'Under $30': [0, 30], '$30 – $50': [30, 50], '$50 – $100': [50, 100], '$100 and over': [100, 1e6] };
  function parseRange(v) {
    if (BAND_RANGES[v]) return BAND_RANGES[v];
    var m = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/.exec(v || '');
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }
  function money(d) { return '$' + Math.round(d); }

  function priceBand(cents) {
    var d = cents / 100;
    if (d < 30) return 'Under $30';
    if (d < 50) return '$30 – $50';
    if (d < 100) return '$50 – $100';
    return '$100 and over';
  }

  function sizeLabel(ml) {
    if (ml >= 3000) return '3 L';
    if (ml >= 1500) return '1.5 L Magnum';
    return ml + ' ml';
  }

  function normaliseType(t) {
    if (!t) return '';
    t = t.trim();
    if (/mystery/i.test(t)) return '';
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  function classify(el, cfg) {
    var tags = splitList(el.getAttribute('data-tags'));
    var d = el.dataset;
    var f = { type: [], other: [], country: [], region: [], grape: [], vintage: [], size: [], body: [], sweetness: [], price: [], extras: [], vivino: [], pairing: [] };
    var vivino = 0;

    var type = normaliseType(d.type);
    tags.forEach(function (tag) {
      var low = tag.toLowerCase();
      if (!type && /(wine|olive oil)$/i.test(tag) && !/mystery/i.test(tag)) type = normaliseType(tag);
      if (cfg.countries[low]) f.country.push(cfg.countries[low]);
      if (cfg.regions[low]) f.region.push(cfg.regions[low]);
      // Combined tags such as "South Tyrol/Alto Adige" or "Piedmont/Roero": try each part.
      else if (low.indexOf('/') > -1) low.split('/').some(function (part) {
        part = part.trim();
        if (cfg.regions[part]) { f.region.push(cfg.regions[part]); return true; }
        return false;
      });
      if (cfg.grapes[low]) f.grape.push(cfg.grapes[low]);
      if (/^(19|20)\d{2}$/.test(tag)) f.vintage.push(tag);
      if (!vivino && low.indexOf('vivino') > -1) vivino = parseFloat(low.replace('vivino', '').replace(/[:\s]/g, '').replace(/^-/, '')) || 0;
      var ml = tag.match(/^(\d{3,4})\s?ml$/i);
      if (ml) f.size.push(sizeLabel(parseInt(ml[1], 10)));
      if (/^light(-| )?bodied/.test(low) || low === 'light') f.body.push('Light-bodied');
      if (/^medium(-| )?bodied/.test(low)) f.body.push('Medium-bodied');
      if (/^full(-| )?bodied/.test(low)) f.body.push('Full-bodied');
      if (low === 'dry' || low === 'bone dry') f.sweetness.push('Dry');
      if (low === 'semi-dry' || low === 'off-dry' || low === 'medium-dry' || low === 'semi dry') f.sweetness.push('Off-dry');
      if (low === 'sweet' || low === 'medium-sweet' || low === 'dessert') f.sweetness.push('Sweet');
      if (low.indexOf('organic') > -1 || low.indexOf('biodynamic') > -1) f.extras.push('Organic / biodynamic');
      if (low === 'special offer') f.extras.push('On offer');
      var pm = tag.match(/^pairs?\s*:\s*(.+)$/i);
      if (pm) f.pairing.push(pm[1].trim());
      if (/de-?alcoholi[sz]ed|alcohol[- ]?free|non-?alcoholic|^0\.0/.test(low)) f.other.push('Alcohol free');
    });

    // Metafields (namespace "wine") win over tags when they exist.
    if (d.mfCountry) f.country = [d.mfCountry];
    if (d.mfRegion) f.region = [d.mfRegion];
    if (d.mfGrape) f.grape = splitList(d.mfGrape);
    if (d.mfVintage) f.vintage = [String(d.mfVintage)];
    if (d.mfSize) f.size = [d.mfSize];
    if (d.mfBody) f.body = [d.mfBody];
    if (d.mfSweetness) f.sweetness = [d.mfSweetness];
    if (d.mfVivino) vivino = parseFloat(d.mfVivino) || vivino;
    // Vivino rating (one decimal), same 4.0 floor as the badge. Filtered as a minimum with a slider.
    if (vivino >= 4 && vivino <= 5) f.vivino = [(Math.round(vivino * 10) / 10).toFixed(1)];

    // Non-wine products (olive oil, ...) get their own filter group instead of "Wine type".
    if (f.other.indexOf('Alcohol free') === -1 && /de-?alcoholi[sz]ed|alcohol[- ]?free|non-?alcoholic/i.test((d.name || '') + ' ' + (d.title || ''))) f.other.push('Alcohol free');
    if (type) {
      if (/wine|champagne|prosecco|spumante|sekt|cava|port|sherry|grappa|brut/i.test(type)) f.type = [type];
      else f.other.push(type);
    }
    var price = parseInt(d.price, 10) || 0;
    var compare = parseInt(d.compare, 10) || 0;
    f.price = [priceBand(price)];
    if (compare > price || /off/i.test(d.promo || '')) f.extras.push('On offer');
    if (d.available === 'true') f.extras.push('In stock only');

    Object.keys(f).forEach(function (k) { f[k] = uniq(f[k]); });

    return {
      el: el,
      facets: f,
      price: price,
      index: parseInt(d.index, 10) || 0,
      date: parseInt(d.date, 10) || 0,
      vintage: f.vintage.length ? parseInt(f.vintage[0], 10) : 0,
      name: (d.name || '').toLowerCase()
    };
  }

  function WpsPlp(root) {
    this.root = root;
    this.perPage = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    this.shown = this.perPage;
    var raw = {};
    try { raw = JSON.parse(root.querySelector('[data-wps-config]').textContent); } catch (e) { raw = {}; }
    var countries = {};
    (raw.countries || '').split(/\r?\n/).forEach(function (c) { c = c.trim(); if (c) countries[c.toLowerCase()] = c; });
    this.cfg = { regions: parseMap(raw.regions), grapes: parseMap(raw.grapes), countries: countries };

    var self = this;
    this.items = Array.prototype.map.call(root.querySelectorAll('.wps-item'), function (el) { return classify(el, self.cfg); });
    this.grid = root.querySelector('[data-wps-grid]');
    var ps = this.items.map(function (it) { return it.price / 100; }).filter(function (x) { return x > 0; });
    this.priceLo = ps.length ? Math.floor(Math.min.apply(null, ps)) : 0;
    this.priceHi = ps.length ? Math.ceil(Math.max.apply(null, ps)) : 0;
    this.selected = {};
    this.sort = 'featured';
    this.readUrl();
    this.flags = {};
    var ft = root.querySelector('template[data-wps-flags]');
    if (ft) Array.prototype.forEach.call(ft.content.querySelectorAll('[data-country]'), function (n) { self.flags[n.getAttribute('data-country')] = n.innerHTML; });
    this.decorateCards();
    this.renderHero();
    this.bind();
    this.enhanceSort();
    this.render();
    this.enhanceGuide();
    this.stickyFacets();
    root.classList.add('is-ready');
  }

  WpsPlp.prototype.decorateCards = function () {
    this.items.forEach(function (it) {
      var slot = it.el.querySelector('[data-wps-facts]');
      if (!slot) return;
      var f = it.facets;
      var place = f.region[0] || f.country[0] || '';
      var bits = [place, f.grape.slice(0, 2).join(' & ')].filter(Boolean); // vintage left out: it is already in the name
      slot.textContent = bits.join(' · ');
    });
  };

  WpsPlp.prototype.readUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var self = this;
    GROUPS.forEach(function (g) {
      var v = params.get('f.' + g.key);
      if (v) self.selected[g.key] = v.split(',');
    });
    var s = params.get('sort');
    if (s) this.sort = s;
    var sel = this.root.querySelector('[data-wps-sort]');
    if (sel) sel.value = this.sort;
  };

  // Sort: replace the native drop-down list (which browsers draw in their own style) with a styled one.
  // The <select> stays in the page as the source of truth; picking an option sets it and fires "change".
  WpsPlp.prototype.enhanceSort = function () {
    var sel = this.root.querySelector('[data-wps-sort]');
    var wrap = sel && sel.closest('.wps-sort');
    if (!wrap || wrap.classList.contains('is-enhanced')) return;
    wrap.classList.add('is-enhanced');
    var uid = 'wps-sort-' + Math.random().toString(36).slice(2, 8);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wps-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', uid);
    var menu = document.createElement('ul');
    menu.className = 'wps-sort__menu';
    menu.id = uid;
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    sel.insertAdjacentElement('afterend', btn);
    wrap.appendChild(menu);
    var tick = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    function sync() {
      var o = sel.options[sel.selectedIndex];
      btn.textContent = o ? o.text : '';
      menu.innerHTML = Array.prototype.map.call(sel.options, function (op) {
        var on = op.value === sel.value;
        return '<li role="option" tabindex="-1" data-value="' + esc(op.value) + '" aria-selected="' + on + '"' + (on ? ' class="is-on"' : '') + '><span>' + esc(op.text) + '</span>' + tick + '</li>';
      }).join('');
    }
    function opts() { return Array.prototype.slice.call(menu.querySelectorAll('[role=option]')); }
    function open() {
      sync();
      menu.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var cur = menu.querySelector('.is-on') || opts()[0];
      if (cur) cur.focus();
      document.addEventListener('click', outside, true);
    }
    function close(refocus) {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', outside, true);
      if (refocus) btn.focus();
    }
    function outside(e) { if (!wrap.contains(e.target)) close(false); }
    function pick(li) {
      var v = li.getAttribute('data-value');
      close(true);
      if (v === sel.value) return;
      sel.value = v;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    }
    // Clicking anywhere on the pill (icon, "Sort by", chevron) toggles the list instead of focusing the hidden select.
    wrap.addEventListener('click', function (e) {
      var li = e.target.closest('[role=option]');
      if (li) { e.preventDefault(); pick(li); return; }
      if (menu.contains(e.target)) return;
      e.preventDefault();
      if (menu.hidden) open(); else close(true);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    menu.addEventListener('keydown', function (e) {
      var list = opts();
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (list[i + 1] || list[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (list[i - 1] || list[list.length - 1]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); list[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); list[list.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) pick(list[i]); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(e.key === 'Escape'); }
    });
    sel.addEventListener('change', sync);
    sync();
  };

  WpsPlp.prototype.writeUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var self = this;
    GROUPS.forEach(function (g) {
      var v = self.selected[g.key];
      if (v && v.length) params.set('f.' + g.key, v.join(','));
      else params.delete('f.' + g.key);
    });
    if (this.sort && this.sort !== 'featured') params.set('sort', this.sort); else params.delete('sort');
    params.delete('page');
    var qs = params.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  };

  WpsPlp.prototype.matches = function (it, exceptKey) {
    var sel = this.selected;
    for (var k in sel) {
      if (k === exceptKey || !sel[k] || !sel[k].length) continue;
      var vals = it.facets[k] || [];
      if (k === 'price') {
        var r = parseRange(sel[k][0]);
        var d = it.price / 100;
        if (r && (d < r[0] || d > r[1])) return false;
        continue;
      }
      if (k === 'vivino') {
        var min = parseFloat(sel[k][0]);
        if (min && !(vals.length && parseFloat(vals[0]) >= min - 0.001)) return false;
        continue;
      }
      if (k === 'extras') {
        // Toggles are AND: each ticked toggle must apply.
        for (var i = 0; i < sel[k].length; i++) if (vals.indexOf(sel[k][i]) === -1) return false;
      } else {
        var hit = false;
        for (var j = 0; j < sel[k].length; j++) if (vals.indexOf(sel[k][j]) > -1) { hit = true; break; }
        if (!hit) return false;
      }
    }
    return true;
  };

  WpsPlp.prototype.counts = function (key) {
    var counts = {};
    var self = this;
    this.items.forEach(function (it) {
      if (key === 'extras') {
        (it.facets.extras || []).forEach(function (v) {
          var probe = (self.selected.extras || []).concat([v]);
          var saved = self.selected.extras;
          self.selected.extras = uniq(probe);
          if (self.matches(it)) counts[v] = (counts[v] || 0) + 1;
          self.selected.extras = saved;
        });
        return;
      }
      if (!self.matches(it, key)) return;
      (it.facets[key] || []).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
    });
    return counts;
  };

  WpsPlp.prototype.allValues = function (key) {
    var vals = [];
    this.items.forEach(function (it) { vals = vals.concat(it.facets[key] || []); });
    vals = uniq(vals);
    var g = GROUPS.filter(function (x) { return x.key === key; })[0];
    if (g.order === 'fixed') {
      var order = FIXED_ORDER[key] || [];
      vals.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    } else if (g.order === 'desc') {
      vals.sort().reverse();
    }
    return vals;
  };

  WpsPlp.prototype.renderGroups = function () {
    var wrap = this.root.querySelector('[data-wps-groups]');
    var self = this;
    var openState = {};
    wrap.querySelectorAll('details[data-key]').forEach(function (d) { openState[d.getAttribute('data-key')] = d.open; });
    var expanded = this.expanded || (this.expanded = {});
    var html = '';

    GROUPS.forEach(function (g) {
      var all = self.allValues(g.key);
      if (all.length < 2 && !(self.selected[g.key] || []).length && g.key !== 'extras' && !g.always) return;
      if (!all.length) return;
      var counts = self.counts(g.key);
      if (g.order !== 'fixed' && g.order !== 'desc') {
        all.sort(function (a, b) { return (counts[b] || 0) - (counts[a] || 0) || a.localeCompare(b); });
      }
      var sel = self.selected[g.key] || [];
      var isOpen = g.key in openState ? openState[g.key] : (g.open || sel.length > 0);
      if (g.key === 'price') {
        html += '<details class="wps-group wps-group--range" data-key="price"' + (isOpen ? ' open' : '') + '>' +
          '<summary class="wps-group__title">' + uiIcon('price', 18) + '<span>' + g.label + '</span>' + (sel.length ? ' <span class="wps-group__n">1</span>' : '') + '</summary>' +
          '<div class="wps-group__body">' + self.rangeHtml() + '</div></details>';
        return;
      }
      if (g.key === 'vivino') {
        html += '<details class="wps-group wps-group--range wps-group--viv" data-key="vivino"' + (isOpen ? ' open' : '') + '>' +
          '<summary class="wps-group__title">' + uiIcon('vivino', 18) + '<span>' + g.label + '</span>' + (sel.length ? ' <span class="wps-group__n">1</span>' : '') + '</summary>' +
          '<div class="wps-group__body">' + self.vivinoHtml(all, counts) + '</div></details>';
        return;
      }
      var limit = g.limit && !expanded[g.key] ? g.limit : all.length;
      html += '<details class="wps-group' + (g.pills ? ' wps-group--pills' : '') + '" data-key="' + g.key + '"' + (isOpen ? ' open' : '') + '>';
      html += '<summary class="wps-group__title">' + uiIcon(g.key, 18) + '<span>' + g.label + '</span>' + (sel.length ? ' <span class="wps-group__n">' + sel.length + '</span>' : '') + '</summary>';
      html += '<div class="wps-group__body">';
      if (g.search && all.length > 10) {
        html += '<input type="search" class="wps-group__search" placeholder="Search ' + g.label.toLowerCase() + 's" data-wps-search="' + g.key + '" aria-label="Search ' + g.label.toLowerCase() + '">';
      }
      html += '<ul class="wps-opts">';
      all.forEach(function (v, i) {
        var c = counts[v] || 0;
        var checked = sel.indexOf(v) > -1;
        var hiddenCls = i >= limit && !checked ? ' is-overflow' : '';
        var disabled = c === 0 && !checked;
        html += '<li class="wps-opt' + hiddenCls + (disabled ? ' is-empty' : '') + '" data-label="' + v.toLowerCase().replace(/"/g, '') + '">' +
          '<label><input type="checkbox" data-group="' + g.key + '" value="' + v.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
          '<span class="wps-opt__box" aria-hidden="true"></span>' + self.optMark(g.key, v) +
          '<span class="wps-opt__label">' + v + '</span><span class="wps-opt__count">' + c + '</span></label></li>';
      });
      html += '</ul>';
      if (g.limit && all.length > g.limit) {
        html += '<button type="button" class="wps-link" data-wps-expand="' + g.key + '">' + (expanded[g.key] ? 'Show fewer' : 'Show all ' + all.length) + '</button>';
      }
      html += '</div></details>';
    });
    wrap.innerHTML = html;
  };

  // Price slider: two thumbs from the cheapest to the dearest wine, with a small histogram.
  // The scale is squared so the busy lower price range gets most of the track.
  var RANGE_STEPS = 1000;
  function posToPrice(t, lo, hi) {
    var p = lo + (hi - lo) * Math.pow(t / RANGE_STEPS, 2);
    if (t <= 0) return lo;
    if (t >= RANGE_STEPS) return hi;
    return p < 100 ? Math.round(p) : Math.round(p / 5) * 5;
  }
  function priceToPos(p, lo, hi) {
    if (hi <= lo) return 0;
    return Math.round(Math.sqrt(Math.max(0, Math.min(1, (p - lo) / (hi - lo)))) * RANGE_STEPS);
  }

  WpsPlp.prototype.rangeHtml = function () {
    var lo = this.priceLo, hi = this.priceHi;
    var r = parseRange((this.selected.price || [])[0]) || [lo, hi];
    var a = Math.max(lo, Math.min(hi, r[0])), b = Math.max(lo, Math.min(hi, r[1]));
    var pa = priceToPos(a, lo, hi), pb = priceToPos(b, lo, hi);
    // Histogram of wines (matching the other filters) in 24 buckets along the track.
    var n = 24, bins = [], max = 1, self = this;
    for (var i = 0; i < n; i++) bins.push(0);
    this.items.forEach(function (it) {
      if (!it.price || !self.matches(it, 'price')) return;
      var k = Math.min(n - 1, Math.floor(priceToPos(it.price / 100, lo, hi) / RANGE_STEPS * n));
      bins[k]++; if (bins[k] > max) max = bins[k];
    });
    var bars = bins.map(function (c, i) {
      var on = (i + 1) / n * RANGE_STEPS >= pa && i / n * RANGE_STEPS <= pb;
      return '<span class="' + (on ? 'is-in' : '') + '" style="height:' + (c ? Math.max(10, c / max * 100) : 0) + '%"></span>';
    }).join('');
    return '<div class="wps-range" data-wps-range data-lo="' + lo + '" data-hi="' + hi + '">' +
      '<div class="wps-range__values"><output data-wps-range-a>' + money(a) + '</output><span aria-hidden="true">–</span><output data-wps-range-b>' + money(b) + '</output></div>' +
      '<div class="wps-range__hist" aria-hidden="true">' + bars + '</div>' +
      '<div class="wps-range__track" style="--a:' + (pa / RANGE_STEPS * 100) + '%;--b:' + (pb / RANGE_STEPS * 100) + '%">' +
        '<input type="range" min="0" max="' + RANGE_STEPS + '" step="1" value="' + pa + '" data-wps-range-input="a" aria-label="Minimum price" aria-valuetext="' + money(a) + '">' +
        '<input type="range" min="0" max="' + RANGE_STEPS + '" step="1" value="' + pb + '" data-wps-range-input="b" aria-label="Maximum price" aria-valuetext="' + money(b) + '">' +
      '</div>' +
      '<div class="wps-range__ends"><span>' + money(lo) + '</span><span>' + money(hi) + '</span></div>' +
      '</div>';
  };

  WpsPlp.prototype.rangeInput = function (input, commit) {
    var box = input.closest('[data-wps-range]');
    var lo = +box.getAttribute('data-lo'), hi = +box.getAttribute('data-hi');
    var ia = box.querySelector('[data-wps-range-input="a"]'), ib = box.querySelector('[data-wps-range-input="b"]');
    var ta = +ia.value, tb = +ib.value;
    if (ta > tb) { if (input === ia) { ta = tb; ia.value = ta; } else { tb = ta; ib.value = tb; } }
    var a = posToPrice(ta, lo, hi), b = posToPrice(tb, lo, hi);
    box.querySelector('[data-wps-range-a]').textContent = money(a);
    box.querySelector('[data-wps-range-b]').textContent = money(b);
    ia.setAttribute('aria-valuetext', money(a)); ib.setAttribute('aria-valuetext', money(b));
    var track = box.querySelector('.wps-range__track');
    track.style.setProperty('--a', (ta / RANGE_STEPS * 100) + '%');
    track.style.setProperty('--b', (tb / RANGE_STEPS * 100) + '%');
    // Keep the thumb you are dragging on top when the two meet.
    ia.style.zIndex = input === ia ? 3 : 2; ib.style.zIndex = input === ib ? 3 : 2;
    var bars = box.querySelectorAll('.wps-range__hist span'), n = bars.length;
    bars.forEach(function (bar, i) { bar.classList.toggle('is-in', (i + 1) / n * RANGE_STEPS >= ta && i / n * RANGE_STEPS <= tb); });
    if (!commit) return;
    this.selected.price = a <= lo && b >= hi ? [] : [a + '-' + b];
    this.shown = this.perPage;
    this.writeUrl();
    this.render();
  };

  // Vivino slider: one thumb for the minimum rating. Stop 0 is "Any", then 4.0 up to the best rating in the range.
  WpsPlp.prototype.vivinoStops = function (all) {
    var top = Math.round(parseFloat(all[0] || '4') * 10), stops = ['any'];
    for (var r = 40; r <= Math.max(top, 41); r++) stops.push((r / 10).toFixed(1));
    return stops;
  };
  WpsPlp.prototype.vivinoCount = function (counts, stop) {
    var n = 0;
    Object.keys(counts).forEach(function (r) { if (stop === 'any' || parseFloat(r) >= parseFloat(stop) - 0.001) n += counts[r]; });
    return n;
  };
  WpsPlp.prototype.vivinoHtml = function (all, counts) {
    var stops = this.vivinoStops(all);
    var cur = (this.selected.vivino || [])[0];
    var pos = Math.max(0, stops.indexOf(cur));
    var last = stops.length - 1;
    var self = this;
    this.vivinoCounts = counts;
    var ticks = stops.map(function (s, i) { return '<span style="left:' + (i / last * 100) + '%"' + (i === pos ? ' class="is-on"' : '') + '>' + (s === 'any' ? 'Any' : s) + '</span>'; }).join('');
    return '<div class="wps-vrange" data-wps-vrange data-stops="' + stops.join(',') + '">' +
      '<div class="wps-vrange__head"><span class="wps-opt__viv wps-vrange__badge" data-wps-vbadge' + (pos ? '' : ' hidden') + '>' + (pos ? stops[pos] : '') + '</span>' +
        '<span class="wps-vrange__text"><b data-wps-vlabel>' + (pos ? stops[pos] + ' and above' : 'Any rating') + '</b><span data-wps-vcount>' + self.vivinoCount(counts, stops[pos]) + (pos ? ' wines' : ' wines rated 4.0+') + '</span></span></div>' +
      '<div class="wps-range__track wps-vrange__track" style="--a:' + (pos / last * 100) + '%;--b:100%">' +
        '<input type="range" min="0" max="' + last + '" step="1" value="' + pos + '" data-wps-vrange-input aria-label="Minimum Vivino rating" aria-valuetext="' + (pos ? stops[pos] + ' and above' : 'Any rating') + '">' +
      '</div>' +
      '<div class="wps-vrange__ticks" aria-hidden="true">' + ticks + '</div>' +
    '</div>';
  };
  WpsPlp.prototype.vivinoInput = function (input, commit) {
    var box = input.closest('[data-wps-vrange]');
    var stops = box.getAttribute('data-stops').split(','), last = stops.length - 1, pos = +input.value, s = stops[pos];
    var label = pos ? s + ' and above' : 'Any rating';
    box.querySelector('[data-wps-vlabel]').textContent = label;
    box.querySelector('[data-wps-vcount]').textContent = this.vivinoCount(this.vivinoCounts || {}, s) + (pos ? ' wines' : ' wines rated 4.0+');
    var badge = box.querySelector('[data-wps-vbadge]');
    badge.hidden = !pos; badge.textContent = pos ? s : '';
    input.setAttribute('aria-valuetext', label);
    box.querySelector('.wps-vrange__track').style.setProperty('--a', (pos / last * 100) + '%');
    box.querySelectorAll('.wps-vrange__ticks span').forEach(function (t, i) { t.classList.toggle('is-on', i === pos); });
    if (!commit) return;
    this.selected.vivino = pos ? [s] : [];
    this.shown = this.perPage;
    this.writeUrl();
    this.render();
  };

  WpsPlp.prototype.rangeLabel = function (v) {
    var r = parseRange(v);
    if (!r) return v;
    if (r[0] <= this.priceLo) return 'Up to ' + money(r[1]);
    if (r[1] >= this.priceHi) return money(r[0]) + ' and over';
    return money(r[0]) + ' – ' + money(r[1]);
  };

  WpsPlp.prototype.optMark = function (key, v) {
    if ((key === 'type' || key === 'other') && WINE_SWATCH[v]) return '<span class="wps-opt__swatch" style="--sw:' + WINE_SWATCH[v] + '"></span>';
    if (key === 'other' && v === 'Alcohol free') return '<span class="wps-opt__zero" aria-hidden="true">0%</span>';
    if (key === 'country' && this.flags[v]) return '<span class="wps-opt__flag">' + this.flags[v] + '</span>';
    if (key === 'pairing') { var pf = pairIcon(v); if (pf) return '<img class="wps-opt__pair" src="' + pf + '" alt="" width="28" height="28" loading="lazy">'; }
    return '';
  };

  // Hero: live stats and a fan of three bottle shots from this collection.
  WpsPlp.prototype.renderHero = function () {
    var items = this.items;
    var stats = this.root.querySelector('[data-wps-stats]');
    if (stats && items.length) {
      function count(fn) { var s = {}; items.forEach(function (it) { [].concat(fn(it)).forEach(function (v) { if (v) s[v] = 1; }); }); return Object.keys(s).length; }
      var wineries = count(function (it) { return it.el.getAttribute('data-vendor'); });
      var regions = count(function (it) { return it.facets.region; });
      var countries = count(function (it) { return it.facets.country; });
      var prices = items.map(function (it) { return parseInt(it.el.getAttribute('data-price'), 10) || 0; }).filter(Boolean);
      var from = prices.length ? Math.min.apply(null, prices) / 100 : 0;
      var rows = [['type', items.length, items.length === 1 ? 'wine' : 'wines']];
      if (wineries > 1) rows.push(['building', wineries, 'wineries']);
      if (countries > 1) rows.push(['country', countries, 'countries']);
      else if (regions > 1) rows.push(['region', regions, 'regions']);
      if (from) rows.push(['price', '$' + (from % 1 ? from.toFixed(2) : from), '', 'Lowest price']);
      stats.innerHTML = rows.map(function (r) {
        // Number on top, small caps label underneath ("From" for the price).
        return '<li><b>' + r[1] + '</b><span>' + (r[3] || r[2]) + '</span></li>';
      }).join('');
      stats.hidden = false;
    }
    var art = this.root.querySelector('[data-wps-hero-art]');
    if (art && !art.children.length) {
      var seen = {};
      var pick = items.filter(function (it) {
        var v = it.el.getAttribute('data-vendor');
        if (!it.el.getAttribute('data-img') || it.el.getAttribute('data-available') !== 'true' || seen[v]) return false;
        seen[v] = 1; return true;
      }).slice(0, 3);
      if (pick.length === 3) {
        art.innerHTML = '<span class="wps-plp__hero-disc"></span>' + pick.map(function (it, i) {
          return '<img class="wps-plp__hero-bottle wps-plp__hero-bottle--' + i + '" src="' + esc(it.el.getAttribute('data-img')) + '" alt="" loading="eager">';
        }).join('');
        this.root.querySelector('.wps-plp__hero').classList.add('has-art');
      }
    }
  };

  WpsPlp.prototype.renderQuick = function () {
    var wrap = this.root.querySelector('[data-wps-quick]');
    if (!wrap) return;
    var self = this;
    var picks = [];
    // Fixed shortcuts chosen by the shop, in this order. A pill only shows when the page has matching wines.
    function add(group, value, label, icon) {
      if (self.allValues(group).indexOf(value) > -1) picks.push([group, value, label || value, icon]);
    }
    add('body', 'Full-bodied', 'Full-bodied', 'bolt');
    if (this.priceLo < 50 && this.priceHi > 50) picks.push(['price', this.priceLo + '-50', 'Under $50', 'coin']);
    add('other', 'Alcohol free', 'Alcohol free', 'alcohol');
    add('size', '1.5 L Magnum', 'Magnums', 'size');
    add('extras', 'Organic / biodynamic', 'Organic', 'leaf');
    var html = '<span class="wps-quick__label">' + uiIcon('sparkle', 16) + 'Popular picks</span><div class="wps-quick__pills">';
    picks.forEach(function (p) {
      var on = (self.selected[p[0]] || []).indexOf(p[1]) > -1;
      var mark = p[3] === 'swatch' ? '<span class="wps-pill__swatch" style="--sw:' + (WINE_SWATCH[p[1]] || '#999') + '"></span>' : uiIcon(p[3], 16);
      html += '<button type="button" class="wps-pill' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-quick-group="' + p[0] + '" data-quick-value="' + esc(p[1]) + '">' + mark + '<span>' + esc(p[2]) + '</span>' + (on ? '<span class="wps-pill__x" aria-hidden="true">×</span>' : '') + '</button>';
    });
    html += '</div>';
    wrap.innerHTML = html;
    wrap.hidden = picks.length < 1;
    // Remember which values have a pill, so the chip row below doesn't repeat them.
    this.quickKeys = picks.map(function (p) { return p[0] + '|' + p[1]; });
  };

  WpsPlp.prototype.renderChips = function () {
    var wrap = this.root.querySelector('[data-wps-chips]');
    var html = '';
    var n = 0;
    var shown = 0;
    var self = this;
    var quick = this.quickKeys || [];
    GROUPS.forEach(function (g) {
      (self.selected[g.key] || []).forEach(function (v) {
        n++;
        // Popular picks are already highlighted in the pill row above.
        if (quick.indexOf(g.key + '|' + v) > -1) return;
        shown++;
        html += '<button type="button" class="wps-chip" data-chip-group="' + g.key + '" data-chip-value="' + esc(v) + '" aria-label="Remove ' + esc(v) + '">' + ((g.key === 'type' || g.key === 'other') && WINE_SWATCH[v] ? '<span class="wps-pill__swatch" style="--sw:' + WINE_SWATCH[v] + '"></span>' : g.key === 'country' && self.flags[v] ? '<span class="wps-opt__flag">' + self.flags[v] + '</span>' : '') + '<span class="wps-chip__group">' + g.label + '</span><span class="wps-chip__value">' + esc(g.key === 'price' ? self.rangeLabel(v) : g.key === 'vivino' ? v + ' and above' : v) + '</span><span class="wps-chip__x" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M2 2l6 6M8 2L2 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span></button>';
      });
    });
    var showClear = shown > 0 || n > 1;
    if (showClear) html = (shown ? '<span class="wps-chips__label">Filtered by</span>' : '') + html + '<button type="button" class="wps-link wps-chips__clear" data-wps-clear>Clear all</button>';
    wrap.innerHTML = html;
    wrap.hidden = !showClear;
    var badge = this.root.querySelector('[data-wps-active-count]');
    if (badge) { badge.textContent = n; badge.hidden = n === 0; }
  };

  WpsPlp.prototype.sorted = function (list) {
    var s = this.sort;
    var cmp = {
      'featured': function (a, b) { return a.index - b.index; },
      'price-asc': function (a, b) { return a.price - b.price || a.index - b.index; },
      'price-desc': function (a, b) { return b.price - a.price || a.index - b.index; },
      // Rated wines (4.0+, as on the badge) first, best first; unrated keep their featured order.
      'vivino-desc': function (a, b) { return (parseFloat(b.facets.vivino[0]) || 0) - (parseFloat(a.facets.vivino[0]) || 0) || a.index - b.index; },
      'newest': function (a, b) { return b.date - a.date || a.index - b.index; },
      'vintage-desc': function (a, b) { return (b.vintage || 0) - (a.vintage || 0) || a.index - b.index; },
      'vintage-asc': function (a, b) { return (a.vintage || 9999) - (b.vintage || 9999) || a.index - b.index; },
      'name-asc': function (a, b) { return a.name.localeCompare(b.name); }
    }[s] || function (a, b) { return a.index - b.index; };
    return list.slice().sort(cmp);
  };

  // Mark each card's price as an Add to cart pill when the card can be added straight away.
  WpsPlp.prototype.priceButtons = function () {
    this.items.forEach(function (it) {
      var price = it.el.querySelector('.title-and-price > .product-price');
      var btn = it.el.querySelector('.form-add-to-cart .add-to-cart-button');
      if (!price || !btn) return;
      var name = it.el.getAttribute('data-name') || 'this wine';
      if (btn.tagName === 'A') { price.setAttribute('data-wps-price-atc', 'options'); }
      else if (!btn.disabled) { price.setAttribute('data-wps-price-atc', 'add'); }
      else return;
      price.setAttribute('role', 'button');
      price.setAttribute('tabindex', '0');
      price.setAttribute('aria-label', (btn.tagName === 'A' ? 'Choose options for ' : 'Add ') + name + (btn.tagName === 'A' ? '' : ' to cart'));
    });
  };

  WpsPlp.prototype.renderGrid = function () {
    var self = this;
    var visible = this.sorted(this.items.filter(function (it) { return self.matches(it); }));
    var frag = document.createDocumentFragment();
    visible.forEach(function (it, i) {
      it.el.hidden = i >= self.shown;
      frag.appendChild(it.el);
    });
    this.items.forEach(function (it) {
      if (visible.indexOf(it) === -1) { it.el.hidden = true; frag.appendChild(it.el); }
    });
    this.grid.appendChild(frag);

    var total = visible.length;
    var mixed = visible.some(function (it) { return it.facets.other.some(function (v) { return v !== 'Alcohol free'; }); });
    var word = mixed ? (total === 1 ? 'product' : 'products') : (total === 1 ? 'wine' : 'wines');
    var all = this.items.length;
    this.root.querySelector('[data-wps-count]').innerHTML = '<b>' + total + '</b> ' + word + (total < all ? ' <span>of ' + all + '</span>' : '');
    this.root.querySelectorAll('[data-wps-close][data-wps-apply]').forEach(function (b) { b.textContent = 'Show ' + total + ' ' + word; });
    this.root.querySelector('[data-wps-noresults]').hidden = total > 0;

    var moreWrap = this.root.querySelector('[data-wps-more-wrap]');
    var showing = Math.min(this.shown, total);
    moreWrap.hidden = total <= this.shown;
    this.root.querySelector('[data-wps-more-status]').textContent = 'Showing ' + showing + ' of ' + total;
    var moreWrap = this.root.querySelector('[data-wps-more-wrap]');
    if (moreWrap) moreWrap.style.setProperty('--wps-progress', (total ? Math.round(showing / total * 100) : 100) + '%');
  };

  WpsPlp.prototype.render = function () {
    this.renderGroups();
    this.renderQuick();
    this.renderChips();
    this.renderGrid();
  };

  WpsPlp.prototype.toggle = function (group, value, on) {
    var list = (this.selected[group] || []).slice();
    var i = list.indexOf(value);
    if (on === undefined) on = i === -1;
    if (on && i === -1) { if (group === 'price') list = []; list.push(value); }
    if (!on && i > -1) list.splice(i, 1);
    this.selected[group] = list;
    this.shown = this.perPage;
    this.writeUrl();
    this.render();
  };

  // Desktop: the filter column stays in view while the products scroll. When it is taller
  // than the window it scrolls with the page until its end is in view, then holds; scrolling
  // back up brings its top back into view (no inner scrollbar).
  WpsPlp.prototype.stickyFacets = function () {
    var aside = this.root.querySelector('[data-wps-facets]');
    if (!aside) return;
    var root = this.root;
    var wide = window.matchMedia('(min-width: 990px)');
    var top = null, lastY = window.pageYOffset, ticking = false;
    function headerBottom() {
      var el = document.elementFromPoint(window.innerWidth / 2, 2);
      for (; el && el !== document.body; el = el.parentElement) {
        if (root.contains(el)) return 0;
        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') return Math.max(0, el.getBoundingClientRect().bottom);
      }
      return 0;
    }
    function update() {
      ticking = false;
      if (!wide.matches) { aside.style.top = ''; top = null; return; }
      var pad = headerBottom() + 16;
      var minTop = Math.min(pad, window.innerHeight - aside.offsetHeight - 16);
      var y = window.pageYOffset;
      if (top === null) top = pad;
      top = Math.max(minTop, Math.min(pad, top - (y - lastY)));
      lastY = y;
      aside.style.top = Math.round(top) + 'px';
    }
    function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (window.ResizeObserver) new ResizeObserver(queue).observe(aside);
    this.updateSticky = queue;
    queue();
  };

  WpsPlp.prototype.setDrawer = function (open) {
    this.root.classList.toggle('wps-drawer-open', open);
    document.documentElement.classList.toggle('wps-lock', open);
    var overlay = this.root.querySelector('.wps-facets__overlay');
    if (overlay) overlay.hidden = !open;
    var btn = this.root.querySelector('[data-wps-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = this.root.querySelector('.wps-facets summary');
      if (first) first.focus();
    } else if (btn && window.matchMedia('(max-width: 989px)').matches) {
      btn.focus();
    }
  };

  WpsPlp.prototype.bind = function () {
    var self = this;
    var root = this.root;
    this.priceButtons();
    // Price as Add to cart (desktop hover): the price pill presses the card's own Add to cart button,
    // so the theme still adds the item and opens the cart drawer.
    function pressPrice(price) {
      var card = price.closest('.product-card');
      var btn = card && card.querySelector('.form-add-to-cart .add-to-cart-button');
      if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
      price.classList.add('is-adding');
      btn.click();
      var done = function () { price.classList.remove('is-adding'); };
      var tries = 0, poll = setInterval(function () { if (!btn.classList.contains('loading') || ++tries > 40) { clearInterval(poll); setTimeout(done, 250); } }, 150);
    }
    root.addEventListener('click', function (e) {
      var price = e.target.closest('[data-wps-price-atc]');
      if (!price || !window.matchMedia('(hover: hover) and (min-width: 992px)').matches) return;
      e.preventDefault();
      pressPrice(price);
    });
    root.addEventListener('keydown', function (e) {
      var price = e.target.closest && e.target.closest('[data-wps-price-atc]');
      if (price && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pressPrice(price); }
    });
    var wide = window.matchMedia('(min-width: 990px)');
    if (wide.addEventListener) wide.addEventListener('change', function () { self.renderQuick(); });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type="checkbox"][data-group]')) self.toggle(t.getAttribute('data-group'), t.value, t.checked);
      if (t.matches('[data-wps-sort]')) { self.sort = t.value; self.writeUrl(); self.renderGrid(); }
      if (t.matches('[data-wps-range-input]')) self.rangeInput(t, true);
      if (t.matches('[data-wps-vrange-input]')) self.vivinoInput(t, true);
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-wps-range-input]')) { self.rangeInput(t, false); return; }
      if (t.matches('[data-wps-vrange-input]')) { self.vivinoInput(t, false); return; }
      if (!t.matches('[data-wps-search]')) return;
      var q = t.value.trim().toLowerCase();
      var group = t.closest('.wps-group');
      group.classList.toggle('is-searching', !!q);
      group.querySelectorAll('.wps-opt').forEach(function (li) {
        li.classList.toggle('is-filtered-out', !!q && li.getAttribute('data-label').indexOf(q) === -1);
      });
    });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, [data-wps-close]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-quick-group')) {
        self.toggle(t.getAttribute('data-quick-group'), t.getAttribute('data-quick-value'));
      } else if (t.hasAttribute('data-chip-group')) {
        self.toggle(t.getAttribute('data-chip-group'), t.getAttribute('data-chip-value'), false);
      } else if (t.hasAttribute('data-wps-clear')) {
        self.selected = {};
        self.shown = self.perPage;
        self.writeUrl();
        self.render();
      } else if (t.hasAttribute('data-wps-expand')) {
        var k = t.getAttribute('data-wps-expand');
        self.expanded[k] = !self.expanded[k];
        self.renderGroups();
      } else if (t.hasAttribute('data-wps-more')) {
        self.shown += self.perPage;
        self.renderGrid();
      } else if (t.hasAttribute('data-wps-open')) {
        self.setDrawer(true);
      } else if (t.hasAttribute('data-wps-close')) {
        self.setDrawer(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('wps-drawer-open')) self.setDrawer(false);
    });
  };

  // Collection guide (SEO copy below the products): an intro header with the country flag,
  // region cards with an icon and the region's winery logos, and a callout for closing sections.
  var GUIDE_ICONS = {
    mountain: '<path d="M2.5 20l6.5-11 4 6.5 2.5-4 6 8.5z"/><path d="M7.4 11.8l1.6 1.4 1.4-1.2"/>',
    cypress: '<path d="M12 2.5c-3 4.6-4.2 8.6-4.2 11.6a4.2 4.2 0 008.4 0c0-3-1.2-7-4.2-11.6z"/><path d="M12 18.5v3"/>',
    wave: '<path d="M2 9.5c2.5-2 4.5-2 7 0s4.5 2 7 0 4.5-2 6 0"/><path d="M2 14.5c2.5-2 4.5-2 7 0s4.5 2 7 0 4.5-2 6 0"/><path d="M2 19.5c2.5-2 4.5-2 7 0s4.5 2 7 0 4.5-2 6 0"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.6 4.6L6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4L6 18M18 6l1.4-1.4"/>',
    volcano: '<path d="M2.5 21l5.5-9h8l5.5 9z"/><path d="M9.5 12l2.5-3 2.5 3M12 6.5V3M8.8 5.2L7.6 3.4M15.2 5.2l1.2-1.8"/>',
    grapes: '<circle cx="8.6" cy="9.4" r="2.1"/><circle cx="12.6" cy="9.4" r="2.1"/><circle cx="16.6" cy="9.4" r="2.1"/><circle cx="10.6" cy="13.2" r="2.1"/><circle cx="14.6" cy="13.2" r="2.1"/><circle cx="12.6" cy="17" r="2.1"/><path d="M12.6 7.3V3.5M12.6 4.6c1.8-1.6 3.8-1.6 5.2-.2"/>',
    pizza: '<path d="M12 3l8.5 15.5a19 19 0 01-17 0z"/><path d="M5.4 15.6a15 15 0 0013.2 0"/><circle cx="10.5" cy="11.5" r="1.1"/><circle cx="13.5" cy="13.8" r="1.1"/>',
    steak: '<path d="M4.5 13.5c0-5 4-8.5 9-8.5 3.6 0 6 2.4 6 5.8 0 4.6-3.6 8.2-9 8.2-3.8 0-6-2-6-5.5z"/><circle cx="14" cy="10.5" r="2.2"/>',
    fish: '<path d="M6 12c2.5-3.5 6-5.5 9.5-5.5 2.5 0 4.5 2 5.5 5.5-1 3.5-3 5.5-5.5 5.5-3.5 0-7-2-9.5-5.5z"/><path d="M6 12L2.5 8.5v7z"/><circle cx="16.5" cy="11" r="1"/>',
    cheese: '<path d="M3 15.5l10-8.5 8 4.5v6.5H3z"/><path d="M3 15.5h18"/><circle cx="8" cy="18.2" r="1"/><circle cx="15" cy="17.8" r="1.1"/><circle cx="12.5" cy="12.6" r=".9"/>',
    truck: '<path d="M2 6.5h11v9H2zM13 9.5h4l3 3v3h-7"/><circle cx="6" cy="17.2" r="1.8"/><circle cx="16" cy="17.2" r="1.8"/>',
    glass: '<path d="M7 3h10l-.8 6.2a4.2 4.2 0 01-8.4 0z"/><path d="M7.4 7h9.2M12 13.4V20M8.2 20.5h7.6"/>'
  };
  var GUIDE_KEYWORDS = [
    ['mountain', /\bnorth|alto adige|dolomit|piedmont|piemonte|aosta|trentino|friuli|alps|alpine|mosel|franconia|pfalz|baden|jura|savoie/],
    ['cypress', /\bcentral|tuscany|toscana|chianti|montalcino/],
    ['wave', /abruzzo|marche|adriatic|liguria|coast|dalmatia|komarna|corsica|istria|atlantic|vinho verde/],
    ['sun', /puglia|umbria|sardinia|south|calabria|basilicata|alentejo|provence|languedoc/],
    ['volcano', /campania|etna|sicily|santorini|azores|pico/]
  ];
  function guideIcon(name) {
    return '<span class="wps-guide__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + GUIDE_ICONS[name] + '</svg></span>';
  }
  // Illustrated food pairing badges (assets/wps-pair-*.png), matched on the pairing title.
  var PAIR_ICONS = [
    [/pizza|pasta/, 'pizza-and-pasta'],
    [/laksa|sichuan/, 'spicy-dishes-laksa-to-sichuan'],
    [/sushi|steamed/, 'seafood-sushi-and-steamed-fish'],
    [/^seafood & fish$/, 'seafood-sushi-and-steamed-fish'],
    [/seafood|fish/, 'seafood-and-spicy-dishes'],
    [/duck|pork/, 'roast-duck-and-pork'],
    [/celebrat|sparkling|aperitif/, 'celebrations'],
    [/barbecue|bbq|grill(ed)? meat/, 'grilled-meats-and-barbecue'],
    [/rendang|curry/, 'beef-rendang-and-braised-dishes'],
    [/^spicy dishes$/, 'spicy-dishes-laksa-to-sichuan'],
    [/cured ham|hard cheese|prosciutto/, 'hard-cheese-and-cured-ham'],
    [/lamb|chicken|poultry/, 'grilled-lamb-and-roast-chicken'],
    [/mediterranean|tomato|olive/, 'mediterranean'],
    [/aged cheese/, 'charcuterie-and-aged-cheese'],
    [/^cheese$/, 'charcuterie-and-aged-cheese'],
    [/^charcuterie$/, 'cheese-and-charcuterie'],
    [/cheese|charcuterie/, 'cheese-and-charcuterie'],
    [/beef|roast|braise|steak|game|meat/, 'braised-beef-and-roasts'],
    [/spicy|asian/, 'seafood-and-spicy-dishes']
  ];
  var ASSET_BASE = (function () {
    var el = document.querySelector('script[src*="wps-collection"]');
    return el ? el.src.split('?')[0].replace(/[^\/]*$/, '') : '';
  })();
  function pairIcon(title) {
    if (!ASSET_BASE) return '';
    var t = (title || '').toLowerCase();
    for (var i = 0; i < PAIR_ICONS.length; i++) if (PAIR_ICONS[i][0].test(t)) return ASSET_BASE + 'wps-pair-' + PAIR_ICONS[i][1] + '.png';
    return '';
  }
  function iconFor(text) {
    var t = text.toLowerCase();
    for (var i = 0; i < GUIDE_KEYWORDS.length; i++) if (GUIDE_KEYWORDS[i][1].test(t)) return GUIDE_KEYWORDS[i][0];
    return 'grapes';
  }

  function layoutGuide(guide) {
    if (guide.dataset.ready) return;
    guide.dataset.ready = '1';
    var logos = {};
    var logoEl = guide.querySelector('[data-wps-guide-logos]');
    if (logoEl) {
      try {
        JSON.parse(logoEl.textContent).forEach(function (row) {
          var p = row.split('|');
          if (p.length >= 3) logos[p[0]] = { url: p[1], title: p.slice(2).join('|').split(' (')[0] };
        });
      } catch (e) { /* no logos */ }
    }
    var flagSrc = guide.querySelector('.wps-guide__flag');
    // Regional coats of arms (region name -> image), shown on the region tiles.
    var crests = {};
    var crestEl = guide.querySelector('[data-wps-guide-crests]');
    if (crestEl) { try { crests = JSON.parse(crestEl.textContent); } catch (e) { crests = {}; } }
    var CREST_ALIASES = { piemonte: 'piedmont', 'südtirol': 'alto adige', 'trentino': 'alto adige', toscana: 'tuscany', apulia: 'puglia' };
    function crestsFor(title) {
      var t = title.toLowerCase(), out = [];
      Object.keys(CREST_ALIASES).forEach(function (a) { if (t.indexOf(a) > -1) t += ' ' + CREST_ALIASES[a]; });
      Object.keys(crests).map(function (k) { return [k, t.indexOf(k)]; })
        .filter(function (x) { return x[1] > -1; })
        .sort(function (a, b) { return a[1] - b[1]; })
        .forEach(function (x) { out.push([x[0], crests[x[0]]]); });
      return out;
    }

    // Jump links: a thin banner at the top of the page linking down to each guide section.
    var jumps = [];
    function jump(el, id, label, icon, count) {
      if (!label) return;
      el.id = el.id || id;
      jumps.push({ id: el.id, label: label, icon: icon, count: count });
    }

    // Split the guide into sections, one per Heading 2.
    var sections = [], cur = null;
    Array.prototype.slice.call(guide.children).forEach(function (node) {
      if (node.tagName === 'SCRIPT' || node === flagSrc) return;
      if (node.tagName === 'H2' || !cur) { cur = { nodes: [] }; sections.push(cur); }
      cur.nodes.push(node);
    });

    sections.forEach(function (sec, i) {
      var hasCards = sec.nodes.some(function (n) { return n.tagName === 'H3'; });
      var anchor = sec.nodes[0];
      var heading = sec.nodes[0] && sec.nodes[0].tagName === 'H2' ? sec.nodes[0].textContent : '';
      if (!hasCards && /taste profile|taste|style profile/i.test(heading)) {
        // Taste profile: text with north/central/south rows, plus live charts of the range.
        var pf = document.createElement('div');
        pf.className = 'wps-guide__profile';
        jump(pf, 'taste-profile', 'Taste profile', 'grapes');
        pf.innerHTML = '<div class="wps-guide__profile-text"></div><div class="wps-guide__profile-stats" data-wps-profile></div>';
        guide.insertBefore(pf, anchor);
        var pt = pf.firstChild;
        sec.nodes.forEach(function (n) {
          if (n.tagName === 'P' && n.firstElementChild && n.firstElementChild.tagName === 'STRONG' && n.textContent.trim().indexOf(n.firstElementChild.textContent.trim()) === 0) {
            var row = document.createElement('div');
            row.className = 'wps-guide__zone';
            row.innerHTML = guideIcon(iconFor(n.firstElementChild.textContent + ' ' + n.textContent));
            n.firstElementChild.classList.add('wps-guide__zone-name');
            row.appendChild(n);
            pt.appendChild(row);
          } else {
            pt.appendChild(n);
          }
        });
        return;
      }
      var list = !hasCards && sec.nodes.filter(function (n) { return n.tagName === 'UL' || n.tagName === 'OL'; })[0];
      if (list) {
        // Structured callout: heading, lead, a grid of tiles from the list, and a footer line.
        var pb = document.createElement('div');
        pb.className = 'wps-guide__pairing';
        jump(pb, 'food-pairing', 'Food pairing', 'pizza');
        pb.innerHTML = '<div class="wps-guide__pairing-head">' + guideIcon('glass') + '<div class="wps-guide__pairing-intro"></div></div><div class="wps-guide__pairing-grid"></div><div class="wps-guide__pairing-foot"></div>';
        guide.insertBefore(pb, anchor);
        var intro = pb.querySelector('.wps-guide__pairing-intro');
        var pgrid = pb.querySelector('.wps-guide__pairing-grid');
        var foot = pb.querySelector('.wps-guide__pairing-foot');
        var afterList = false;
        sec.nodes.forEach(function (n) {
          if (n === list) {
            afterList = true;
            Array.prototype.slice.call(n.children).forEach(function (li, k) {
              var strong = li.querySelector('strong, b');
              var title = strong ? strong.textContent.replace(/[:\s]+$/, '') : '';
              if (strong) strong.parentNode.removeChild(strong);
              var t = (title + ' ' + li.textContent).toLowerCase();
              var ic = /pizza|pasta/.test(t) ? 'pizza' : /beef|roast|meat|lamb|steak|game/.test(t) ? 'steak' : /seafood|fish|spicy|asian|sushi/.test(t) ? 'fish' : /cheese|charcuterie/.test(t) ? 'cheese' : 'glass';
              var tile = document.createElement('div');
              tile.className = 'wps-guide__pair';
              var pic = pairIcon(title);
              tile.innerHTML = (pic ? '<span class="wps-guide__icon wps-guide__icon--img" aria-hidden="true"><img src="' + pic + '" alt="" width="88" height="88" loading="lazy"></span>' : guideIcon(ic)) + '<div><span class="wps-guide__pair-title"></span><span class="wps-guide__pair-wine"></span></div>';
              tile.querySelector('.wps-guide__pair-title').textContent = title;
              var wine = tile.querySelector('.wps-guide__pair-wine');
              while (li.firstChild) wine.appendChild(li.firstChild);
              if (wine.firstChild && wine.firstChild.nodeType === 3) wine.firstChild.textContent = wine.firstChild.textContent.replace(/^[\s:–-]+/, '');
              pgrid.appendChild(tile);
            });
            n.parentNode && n.parentNode.removeChild(n);
          } else if (afterList) {
            foot.appendChild(n);
          } else {
            intro.appendChild(n);
          }
        });
        if (foot.childNodes.length) foot.insertAdjacentHTML('afterbegin', guideIcon('truck')); else foot.parentNode.removeChild(foot);
        return;
      }
      if (!hasCards) {
        var box = document.createElement('div');
        box.className = 'wps-guide__callout';
        jump(box, 'guide-' + i, heading.trim(), 'glass');
        box.innerHTML = guideIcon('glass');
        var body = document.createElement('div');
        body.className = 'wps-guide__callout-body';
        guide.insertBefore(box, anchor);
        sec.nodes.forEach(function (n) { body.appendChild(n); });
        box.appendChild(body);
        return;
      }
      // Hero band: heading + intro.
      var hero = document.createElement('div');
      hero.className = 'wps-guide__hero';
      jump(hero, 'wine-regions', 'Wine regions', 'mountain', sec.nodes.filter(function (n) { return n.tagName === 'H3'; }).length);
      guide.insertBefore(hero, anchor);
      var grid = document.createElement('div');
      grid.className = 'wps-guide__grid';
      guide.insertBefore(grid, hero.nextSibling);
      var card = null, text = null;
      sec.nodes.forEach(function (node) {
        if (node.tagName === 'H3') {
          var icon = iconFor(node.textContent);
          card = document.createElement('article');
          card.className = 'wps-guide__card';
          card.innerHTML = '<div class="wps-guide__media" data-icon="' + icon + '">' + guideIcon(icon) + '<div class="wps-guide__bottles"></div><span class="wps-guide__count" hidden></span></div>' +
            '<div class="wps-guide__body"><div class="wps-guide__title"></div><p class="wps-guide__meta" hidden></p><div class="wps-guide__grapes" hidden></div>' +
            '<div class="wps-guide__text"></div><button type="button" class="wps-guide__more" hidden>Read more</button></div>';
          card.querySelector('.wps-guide__title').appendChild(node);
          var arms = crestsFor(node.textContent);
          if (arms.length) {
            // Coats of arms as a faint watermark in the card background.
            card.classList.add('has-crests');
            var cw = document.createElement('div');
            cw.className = 'wps-guide__watermark';
            cw.setAttribute('aria-hidden', 'true');
            cw.innerHTML = arms.slice(0, 3).map(function (a) { return '<img src="' + a[1] + '" alt="" loading="lazy">'; }).join('');
            card.insertBefore(cw, card.firstChild);
          }
          text = card.querySelector('.wps-guide__text');
          grid.appendChild(card);
        } else if (card) {
          text.appendChild(node);
        } else {
          hero.appendChild(node);
        }
      });
      var h2 = hero.querySelector('h2');
      if (i === 0 && h2 && flagSrc && flagSrc.firstElementChild) {
        var f = document.createElement('span');
        f.className = 'wps-guide__hflag';
        f.setAttribute('aria-hidden', 'true');
        f.appendChild(flagSrc.firstElementChild.cloneNode(true));
        h2.insertBefore(f, h2.firstChild);
      }
      grid.querySelectorAll('.wps-guide__card').forEach(function (c) {
        var seen = {}, tiles = '';
        c.querySelectorAll('.wps-guide__text a[href*="/collections/"]').forEach(function (a) {
          var handle = (a.getAttribute('href').split('?')[0].split('/collections/')[1] || '').replace(/\/$/, '');
          var l = logos[handle];
          if (!l || seen[handle]) return;
          seen[handle] = 1;
          tiles += '<a class="wps-guide__winery" href="' + a.getAttribute('href') + '" title="' + l.title.replace(/"/g, '&quot;') + '"><img src="' + l.url + '" alt="' + l.title.replace(/"/g, '&quot;') + '" loading="lazy" width="100" height="60"></a>';
        });
        var body = c.querySelector('.wps-guide__body');
        if (tiles) {
          var w = document.createElement('div');
          w.className = 'wps-guide__logos';
          w.innerHTML = tiles;
          body.appendChild(w);
        }
        // Long text collapses to a teaser with "Read more".
        var t = c.querySelector('.wps-guide__text');
        var more = c.querySelector('.wps-guide__more');
        requestAnimationFrame(function () {
          if (t.scrollHeight > t.clientHeight + 8) {
            more.hidden = false;
            more.addEventListener('click', function () {
              var open = c.classList.toggle('is-open');
              more.textContent = open ? 'Read less' : 'Read more';
            });
          } else {
            c.classList.add('is-open');
          }
        });
      });
    });
    var slot = document.querySelector('[data-wps-guide-jumps]');
    if (slot && jumps.length) {
      var flag = flagSrc && flagSrc.firstElementChild ? '<span class="wps-jumps__flag" aria-hidden="true">' + flagSrc.innerHTML + '</span>' : '';
      var country = guide.getAttribute('data-country');
      var NATION = { italy: 'Italian', germany: 'German', france: 'French', croatia: 'Croatian', austria: 'Austrian', spain: 'Spanish', portugal: 'Portuguese' };
      var name = country ? (NATION[country] || country.charAt(0).toUpperCase() + country.slice(1)) : '';
      slot.innerHTML = '<div class="wps-jumps" data-country="' + (country || '') + '">' + flag +
        '<span class="wps-jumps__label">' + (name ? 'Our ' + name + ' wine guide' : 'Wine guide') + '</span>' +
        '<nav class="wps-jumps__links" aria-label="Wine guide">' + jumps.map(function (j) {
          return '<a href="#' + j.id + '">' + guideIcon(j.icon) + '<span>' + j.label.replace(/</g, '&lt;') + (j.count ? ' <b>' + j.count + '</b>' : '') + '</span></a>';
        }).join('') + '</nav></div>';
      slot.hidden = false;
      slot.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"]');
        if (!a) return;
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
        history.replaceState(null, '', a.getAttribute('href') + '');
      });
    }
  }

  // Region tiles: bottle shots, wine count, starting price, top grapes and a "Shop" button,
  // all taken from the products listed on this page.
  WpsPlp.prototype.enhanceGuide = function () {
    var guide = this.root.querySelector('.wps-plp__guide');
    if (!guide) return;
    var self = this;
    var items = this.items;
    function uniqCount(fn) { var s = {}; items.forEach(function (it) { fn(it).forEach(function (v) { if (v) s[v] = 1; }); }); return Object.keys(s).length; }
    // Stats in the hero band.
    var hero = guide.querySelector('.wps-guide__hero');
    if (hero && items.length) {
      var wineries = uniqCount(function (it) { return [it.el.getAttribute('data-vendor')]; });
      var regions = uniqCount(function (it) { return it.facets.region; });
      var stats = document.createElement('div');
      stats.className = 'wps-guide__stats';
      stats.innerHTML = '<span><b>' + items.length + '</b> wines</span><span><b>' + wineries + '</b> family wineries</span>' + (regions ? '<span><b>' + regions + '</b> regions</span>' : '');
      hero.appendChild(stats);
    }
    // Apply filters from the guide (grape chips, profile bars and links to this page) without reloading.
    function applyFilters(sel) {
      self.selected = sel;
      self.shown = self.perPage;
      self.writeUrl();
      self.render();
      // The toolbar can be sticky, so its live position is wherever it is stuck. Measure its
      // natural place (sticky off for a moment) so the customer lands at the top of the list.
      var tb = self.root.querySelector('.wps-plp__toolbar');
      if (!tb || !tb.offsetHeight) tb = self.root.querySelector('.wps-plp__deck') || self.root; // desktop: toolbar is folded into the deck
      var prev = tb.style.position;
      tb.style.position = 'static';
      var top = tb.getBoundingClientRect().top + window.pageYOffset - 90;
      tb.style.position = prev;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    this.applyFilters = applyFilters;
    guide.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wps-apply]');
      if (b) {
        e.preventDefault();
        var sel = {}; sel[b.getAttribute('data-wps-apply')] = [b.getAttribute('data-value')];
        applyFilters(sel);
        return;
      }
      var a = e.target.closest('a[href]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
      var sel2 = {}, any = false;
      url.searchParams.forEach(function (v, k) { if (k.indexOf('f.') === 0) { sel2[k.slice(2)] = v.split(','); any = true; } });
      if (!any) return;
      e.preventDefault();
      applyFilters(sel2);
    });

    // Taste profile: live charts of the range on this page.
    var prof = guide.querySelector('[data-wps-profile]');
    if (prof && items.length) {
      var SW = WINE_SWATCH;
      function chart(title, key, order, colours) {
        var c = {}, n = 0;
        items.forEach(function (it) { if (it.facets[key].length) { n++; it.facets[key].forEach(function (v) { c[v] = (c[v] || 0) + 1; }); } });
        if (!n) return '';
        var vals = (order || Object.keys(c).sort(function (a, b) { return c[b] - c[a]; })).filter(function (v) { return c[v]; });
        return '<div class="wps-guide__chart"><p class="wps-guide__chart-title">' + title + '</p>' + vals.map(function (v, i) {
          var pct = Math.round(c[v] / n * 100);
          var col = (colours && colours[v]) || ('color-mix(in srgb, var(--g1) ' + (100 - i * 22) + '%, #fff)');
          return '<button type="button" class="wps-guide__bar" data-wps-apply="' + key + '" data-value="' + v.replace(/"/g, '&quot;') + '"><span class="wps-guide__bar-label">' + v.replace(/ wine$/, '') + '</span><span class="wps-guide__bar-track"><span style="width:' + Math.max(pct, 3) + '%;background:' + col + '"></span></span><span class="wps-guide__bar-pct">' + pct + '%</span></button>';
        }).join('') + '</div>';
      }
      prof.innerHTML = '<p class="wps-guide__stats-title">Our range at a glance</p>' +
        chart('Wine style', 'type', null, SW) +
        chart('Body', 'body', ['Light-bodied', 'Medium-bodied', 'Full-bodied']) +
        chart('Sweetness', 'sweetness', ['Dry', 'Off-dry', 'Sweet']) +
        '<p class="wps-guide__stats-note">Based on the ' + items.length + ' wines in this collection. Tap a bar to filter.</p>';
    } else if (prof) {
      prof.parentNode.removeChild(prof);
    }

    var allRegions = this.allValues('region');
    guide.querySelectorAll('.wps-guide__card').forEach(function (card) {
      var name = card.querySelector('h3').textContent.toLowerCase();
      var parts = name.split(/,|\band\b|&|\//).map(function (p) { return p.trim(); }).filter(Boolean);
      var vals = allRegions.filter(function (r) {
        var rl = r.toLowerCase();
        return parts.some(function (p) { return rl === p || rl.indexOf(p) > -1 || p.indexOf(rl) > -1; });
      });
      if (!vals.length) return;
      var list = items.filter(function (it) { return it.facets.region.some(function (r) { return vals.indexOf(r) > -1; }); });
      if (!list.length) return;
      // Region name links to the filtered view.
      var h3 = card.querySelector('h3');
      if (!h3.querySelector('a')) {
        var ra = document.createElement('a');
        ra.href = window.location.pathname + '?f.region=' + encodeURIComponent(vals.join(','));
        ra.textContent = h3.textContent;
        h3.textContent = '';
        h3.appendChild(ra);
      }
      // Count, starting price, top grapes.
      var count = card.querySelector('.wps-guide__count');
      count.textContent = list.length + (list.length === 1 ? ' wine' : ' wines');
      count.hidden = false;
      var min = Math.min.apply(null, list.map(function (it) { return it.price || Infinity; }));
      var meta = card.querySelector('.wps-guide__meta');
      if (isFinite(min)) { meta.textContent = 'From $' + (min / 100).toFixed(2); meta.hidden = false; }
      var g = {};
      list.forEach(function (it) { it.facets.grape.forEach(function (v) { g[v] = (g[v] || 0) + 1; }); });
      var top = Object.keys(g).sort(function (a, b) { return g[b] - g[a]; }).slice(0, 3);
      if (top.length) {
        var gw = card.querySelector('.wps-guide__grapes');
        gw.innerHTML = top.map(function (v) { return '<button type="button" data-wps-apply="grape" data-value="' + v.replace(/"/g, '&quot;') + '">' + v.replace(/</g, '&lt;') + '</button>'; }).join('');
        gw.hidden = false;
      }
      // Up to three bottle shots, in stock first.
      var pics = list.slice().sort(function (a, b) {
        var av = a.facets.extras.indexOf('In stock only') > -1 ? 0 : 1, bv = b.facets.extras.indexOf('In stock only') > -1 ? 0 : 1;
        return av - bv || a.index - b.index;
      }).map(function (it) { return it.el.getAttribute('data-img'); }).filter(Boolean);
      var seen = {}, html = '';
      pics.forEach(function (src) { if (!seen[src] && Object.keys(seen).length < 3) { seen[src] = 1; html += '<img src="' + src + '" alt="" loading="lazy">'; } });
      if (html) {
        card.querySelector('.wps-guide__bottles').innerHTML = html;
        card.querySelector('.wps-guide__media').classList.add('has-bottles');
      }
      // Shop button: filters the products above to this region.
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wps-guide__shop';
      var label = card.querySelector('h3').textContent.trim();
      btn.innerHTML = 'Shop ' + label.replace(/</g, '&lt;') + ' <span aria-hidden="true">→</span>';
      btn.addEventListener('click', function () { applyFilters({ region: vals.slice() }); });
      card.querySelector('.wps-guide__body').appendChild(btn);
    });
  };

  // Quick view pop-up (the theme's): click an image to open a full-screen viewer with
  // previous/next, click-to-zoom and pan. Built once, re-wired each time the pop-up loads a product.
  function bigSrc(img) {
    var host = img.closest('[data-zoom]');
    var src = (host && host.getAttribute('data-zoom')) || img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (!src) return '';
    try { var u = new URL(src, window.location.href); u.searchParams.set('width', '2000'); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.toString(); } catch (e) { return src; }
  }
  var qvLb = null;
  function quickViewLightbox() {
    if (qvLb) return qvLb;
    var lb = document.createElement('div');
    lb.className = 'wps-qvlb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    var chev = function (d) { return '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
    lb.innerHTML = '<div class="wps-qvlb__stage"><img class="wps-qvlb__img" alt=""></div>' +
      '<button type="button" class="wps-qvlb__btn wps-qvlb__close" aria-label="Close">' + chev('M6 6l12 12M18 6L6 18') + '</button>' +
      '<button type="button" class="wps-qvlb__btn wps-qvlb__prev" aria-label="Previous image">' + chev('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="wps-qvlb__btn wps-qvlb__next" aria-label="Next image">' + chev('M9 5l7 7-7 7') + '</button>' +
      '<p class="wps-qvlb__count" aria-live="polite"></p><p class="wps-qvlb__hint">Click the image to zoom</p>';
    document.body.appendChild(lb);
    var img = lb.querySelector('.wps-qvlb__img'), stage = lb.querySelector('.wps-qvlb__stage');
    var st = { list: [], i: 0, zoomed: false };
    function pan(e) {
      var r = stage.getBoundingClientRect();
      var pt = e.touches ? e.touches[0] : e;
      var x = Math.min(100, Math.max(0, (pt.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (pt.clientY - r.top) / r.height * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    function zoom(on, e) { st.zoomed = on; lb.classList.toggle('is-zoomed', on); if (on && e) pan(e); if (!on) img.style.transformOrigin = ''; }
    function load(i) {
      var n = st.list.length;
      st.i = (i + n) % n;
      zoom(false);
      img.src = st.list[st.i];
      lb.querySelector('.wps-qvlb__count').textContent = n > 1 ? (st.i + 1) + ' / ' + n : '';
      lb.classList.toggle('is-single', n < 2);
    }
    function close() { lb.hidden = true; document.documentElement.classList.remove('wps-qvlb-open'); if (st.from) st.from.focus(); }
    lb.querySelector('.wps-qvlb__close').addEventListener('click', close);
    lb.querySelector('.wps-qvlb__prev').addEventListener('click', function () { load(st.i - 1); });
    lb.querySelector('.wps-qvlb__next').addEventListener('click', function () { load(st.i + 1); });
    stage.addEventListener('click', function (e) { if (e.target === img) zoom(!st.zoomed, e); else close(); });
    stage.addEventListener('mousemove', function (e) { if (st.zoomed) pan(e); });
    stage.addEventListener('touchmove', function (e) { if (st.zoomed) { e.preventDefault(); pan(e); } }, { passive: false });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null || st.zoomed) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) load(st.i + (dx < 0 ? 1 : -1));
    });
    // Capture phase so Esc closes only the viewer, not the quick view behind it.
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
      else if (e.key === 'ArrowLeft') load(st.i - 1);
      else if (e.key === 'ArrowRight') load(st.i + 1);
    }, true);
    qvLb = {
      open: function (list, i, from) {
        st.list = list; st.from = from;
        lb.hidden = false;
        document.documentElement.classList.add('wps-qvlb-open');
        load(i);
        lb.querySelector('.wps-qvlb__close').focus();
      }
    };
    return qvLb;
  }
  function sizedSrc(src, w) {
    try { var u = new URL(src, window.location.href); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; }
  }
  // Replace the theme's quick view slider with a simple gallery we control: big image, arrows, swipe and thumbnails.
  function buildQuickGallery(content) {
    var gal = content.querySelector('.product-gallery');
    if (!gal || gal.classList.contains('is-wps')) return;
    var list = [];
    Array.prototype.forEach.call(gal.querySelectorAll('img'), function (m) {
      if (m.closest('.swiper-slide-duplicate')) return;
      var src = bigSrc(m);
      if (src && list.indexOf(src) < 0) list.push(src);
    });
    if (!list.length) return;
    gal.classList.add('is-wps');
    var chev = function (d) { return '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
    var g = document.createElement('div');
    g.className = 'wps-qvg' + (list.length < 2 ? ' is-single' : '');
    g.innerHTML = '<div class="wps-qvg__stage"><img class="wps-qvg__img" alt="" src="' + esc(sizedSrc(list[0], 1200)) + '">' +
      '<button type="button" class="wps-qvg__nav wps-qvg__prev" aria-label="Previous image">' + chev('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="wps-qvg__nav wps-qvg__next" aria-label="Next image">' + chev('M9 5l7 7-7 7') + '</button>' +
      '<span class="wps-qvg__zoom" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/></svg></span></div>' +
      (list.length > 1 ? '<div class="wps-qvg__thumbs">' + list.map(function (src, i) {
        return '<button type="button" class="wps-qvg__thumb' + (i ? '' : ' is-on') + '" data-i="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + esc(sizedSrc(src, 200)) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div>' : '');
    gal.appendChild(g);
    var img = g.querySelector('.wps-qvg__img');
    var idx = 0;
    function show(i) {
      idx = (i + list.length) % list.length;
      img.src = sizedSrc(list[idx], 1200);
      Array.prototype.forEach.call(g.querySelectorAll('.wps-qvg__thumb'), function (t, n) { t.classList.toggle('is-on', n === idx); });
    }
    g.querySelector('.wps-qvg__prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    g.querySelector('.wps-qvg__next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    Array.prototype.forEach.call(g.querySelectorAll('.wps-qvg__thumb'), function (t) {
      t.addEventListener('click', function (e) { e.stopPropagation(); show(parseInt(t.getAttribute('data-i'), 10)); });
    });
    g.querySelector('.wps-qvg__stage').addEventListener('click', function (e) {
      if (e.target.closest('.wps-qvg__nav')) return;
      e.preventDefault(); e.stopPropagation();
      quickViewLightbox().open(list, idx, img);
    });
    var x0 = null;
    img.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    });
  }
  function wireQuickView(box) {
    var content = box.querySelector('.quick-view-content');
    if (!content) return;
    buildQuickGallery(content);
    new MutationObserver(function () { buildQuickGallery(content); }).observe(content, { childList: true });
  }

  // Featured wines / You recently viewed (.wps-cards): same price pill as the PLP cards.
  function markCards() {
    document.querySelectorAll('.wps-cards .product-card').forEach(function (card) {
      var price = card.querySelector('.title-and-price > .product-price');
      var btn = card.querySelector('.form-add-to-cart .add-to-cart-button');
      if (!price || !btn || price.hasAttribute('data-wps-price-atc')) return;
      var t = card.querySelector('.product-title');
      var name = t ? t.textContent.trim() : 'this wine';
      if (btn.tagName === 'A') price.setAttribute('data-wps-price-atc', 'options');
      else if (!btn.disabled) price.setAttribute('data-wps-price-atc', 'add');
      else return;
      price.setAttribute('role', 'button');
      price.setAttribute('tabindex', '0');
      price.setAttribute('aria-label', (btn.tagName === 'A' ? 'Choose options for ' : 'Add ') + name + (btn.tagName === 'A' ? '' : ' to cart'));
    });
  }
  function pressCardPrice(price) {
    var card = price.closest('.product-card');
    var btn = card && card.querySelector('.form-add-to-cart .add-to-cart-button');
    if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
    price.classList.add('is-adding');
    btn.click();
    var tries = 0, poll = setInterval(function () { if (!btn.classList.contains('loading') || ++tries > 40) { clearInterval(poll); setTimeout(function () { price.classList.remove('is-adding'); }, 250); } }, 150);
  }
  if (!window.__wpsCardsWired) {
    window.__wpsCardsWired = true;
    document.addEventListener('click', function (e) {
      var price = e.target.closest && e.target.closest('.wps-cards [data-wps-price-atc]');
      if (!price || !window.matchMedia('(hover: hover) and (min-width: 992px)').matches) return;
      e.preventDefault(); e.stopPropagation();
      pressCardPrice(price);
    }, true);
    document.addEventListener('keydown', function (e) {
      var price = e.target.closest && e.target.closest('.wps-cards [data-wps-price-atc]');
      if (price && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pressCardPrice(price); }
    });
    var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(markCards, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    markCards();
    document.querySelectorAll('.wps-plp__guide').forEach(layoutGuide);
    document.querySelectorAll('[data-wps-plp]:not(.is-ready)').forEach(function (el) { new WpsPlp(el); });
    var qv = document.querySelector('.quick-view');
    if (qv && !qv.hasAttribute('data-wps-wired')) { qv.setAttribute('data-wps-wired', ''); wireQuickView(qv); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
